<template>
  <div class="isotope-wrapper" v-if="offerList.length > 0">
    <div class="row">
      <div
        class="col-md-6 isotope-item popular"
        v-for="offer in offerList"
        :key="offer.id"
      >
        <div class="box_grid">
            <small class="text-left">{{offer.status==='1'?'Featured':''}}</small>
          <figure>
            <small>{{ offer.company_name }}</small>
            <router-link :to="'/offer-post-single/' + offer.id"

              ><img
               :src="
                  offer.image !== null
                    ? `${imagepath.liveimagepath}offer-images/`+
                      offer.image
                    :'https://peekzy.in/backend/public/assets/uploads/no-image.png'"
                class="img-fluid"
                height="200px"
              />
              <div class="read_more"><span>View Profile</span></div></router-link>
          </figure>
          <div class="wrapper">
            <!-- <a href="#0" class="wish_bt"></a> -->
            <h3>
              <a :href="'/offer-details/' + offer.slug">{{
                offer.short_description
              }}</a>
            </h3>

            <!-- <div v-html="offer.description">
              {{ offer.description }}
            </div> -->
            <p class="location">
              <span class="col-md-6 pull-left">
                <i class="fa fa-map-marker"></i> {{ offer.pincode }}
              </span>
              <span class="col-md-6 pull-right">
                <i class="fa fa-map"></i> {{ offer.location }}
              </span>
            </p>
            <span class="price" v-if="offer.offer_in == 'percent'">
              Discount Upto <strong>{{ offer.offer_value }}%</strong>
            </span>
            <!-- <span class="price" v-else>
              Upto
              <strong><i class="fa fa-inr"></i> {{ offer.offer_value }}</strong>
            </span> -->
            <br>
             <strong class="mt-3" v-for="cat in offer.categories" :key="cat.category_id">Categories: {{ cat.category +' ,' }}</strong>
            
          </div>
          
          <ul>
            <li>
              <i class="icon_clock_alt"></i> <b>Validity:</b>
              {{ validity(offer.valid_till) }}
            </li>
            <li>
              <!-- <div class="score">
                <span>Superb<em>0 Reviews</em></span
                ><strong>10</strong>
              </div> -->
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="box_list isotope-item popular">
      <div class="row no-gutters">
        <div class="col-lg-12">
          <center><h5 class="mt-3">No Matching Record Found.</h5></center>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import imagepath from "../services/variables.js";

export default {
  props: {
    offerList: {
      type: Array,
    },
  },
    data() {
    return {
imagepath:imagepath
    }
  },
  methods: {
    validity(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    },
  },
};
</script>
<style scoped>
.location {
  min-height: 50px;
  vertical-align: middle;
}

.box_list {
  min-height: 310px;
}
</style>